




























import { Component, Vue } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import ProjectsData from '@/ts/ProjectsData';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        FlexibleTable,
    },
})
export default class ProjectList extends Vue {
    public tableEntity: string = 'ProjectList';

    constructor() {
        super();
    }

    get columns(): any {
        return [
            { name: 'id', label: this.$t('general.project-id', 'Project ID'), align: 'left', field: 'id', sortable: true, required: true },
            { name: 'name', label: this.$t('general.name', 'Project name'), align: 'left', field: 'name', sortable: true, required: false },
            { name: 'description', label: this.$t('general.description', 'Description'), align: 'left', field: 'description', sortable: true, required: false },
            { name: 'owner', label: this.$t('general.owner', 'Owner'), align: 'left', field: 'owner', sortable: true, required: false },
            { name: 'totalProperties', label: this.$t('general.properties', 'Properties'), align: 'left', field: 'totalProperties', sortable: true, required: false },
            { name: 'totalResidents', label: this.$t('general.residents', 'Residents'), align: 'left', field: 'totalResidents', sortable: true, required: false },
            { name: 'totalVacantProperties', label: this.$t('general.vacant-properties', 'Vacant properties'), align: 'left', field: 'totalVacantProperties', sortable: true, required: false },
            { name: 'vacancyRate', label: this.$t('general.vacancy-rate', 'Vacancy rate'), align: 'left', field: 'vacancyRate', sortable: true, required: false,
                sort: (a: any, b: any) => {
                    const aValue = Number(a.split('%')[0]);
                    const bValue = Number(b.split('%')[0]);

                    return aValue - bValue;
                },
            },
        ];
    }

    get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'id',
                'name',
                'description',
            ],
        };
    }

    get filteredProjects(): ProjectsData[] {
        return this.$store.getters['Projects/allProjects'];
    }

    public selectItem(id: number) {
        this.$store.commit(Mutations.SELECT_PROJECT, id);
        this.$router.push({path: '/admin/unit-groups'});
    }
}
